export default {
    parts: [
        'container',
        'header',
        'titleRow',
        'icon',
        'label',
        'closeButton',
        'closeIcon',
        'body',
        'message',
        'link'
    ],
    baseStyle: {
        container: {
            backgroundColor: 'webTheme.redTint',
            p: 4,
            width: '100%'
        },
        header: {
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        titleRow: {
            alignItems: 'center',
            gap: 2
        },
        icon: {
            boxSize: 5
        },
        label: {
            textStyle: 'labelXs'
        },
        closeButton: {
            variant: 'unstyled',
            minW: 'auto',
            h: 'auto',
            p: 0
        },
        closeIcon: {
            boxSize: 6,
            color: 'webTypo.textPrimary'
        },
        body: {
            mt: 1
        },
        message: {
            textStyle: 'bodyXsRegular'
        },
        linkText: {
            textDecoration: 'underline',
            textStyle: 'bodyXsLink'
        }
    }
}
